import React from "react";
import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Header, Footer } from "./components/Layout";

// Pages
import Dashboard from "./pages/Dashboard";
import Territorios from "./pages/Territorios";
import TerritoryDetail from "./pages/TerritoryDetail";
import Dependencias from "./pages/Dependencias";
import DependencyDetail from "./pages/DependencyDetail";
import ResumenSemanal from "./pages/ResumenSemanal";
import Login from "./pages/Login";
import CargarActividad from "./pages/CargarActividad";
import MisActividades from "./pages/MisActividades";
import Admin from "./pages/Admin";
import ActivityDetail from "./pages/ActivityDetail";

import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />

        <div className="flex flex-col min-h-screen bg-[#F5F0E1]">
          <Header />

          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/territorios" element={<Territorios />} />
              <Route path="/territorio/:id" element={<TerritoryDetail />} />
              <Route path="/dependencias" element={<Dependencias />} />
              <Route path="/dependencia/:id" element={<DependencyDetail />} />
              <Route path="/resumen" element={<ResumenSemanal />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cargar-actividad" element={<CargarActividad />} />
              <Route path="/actividad/:id/editar" element={<CargarActividad />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/actividad/:id" element={<ActivityDetail />} />
              <Route path="/mis-actividades" element={<MisActividades />} />
            </Routes>
          </main>

          <Footer />
        </div>

        <Toaster position="top-right" richColors />
      </Router>
    </AuthProvider>
  );
}

export default App;